<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
defineProps({
  offerEmptyState: { type: Object, default: () => ({}) },
  loadError: { type: Boolean, default: false },
  canLoadMore: { type: Boolean, default: false },
});

const emit = defineEmits(['refresh', 'loadMore']);

const refreshOffers = () => emit('refresh');
const loadMoreOffers = () => emit('loadMore');
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <div class="rounded-lais border border-lais-border p-8 text-center">
    <span
      class="i-lucide-file-search inline-block size-8 text-lais-text-muted mb-3"
    />
    <p class="text-[14px] font-semibold text-lais-text">
      {{ offerEmptyState.title }}
    </p>
    <p
      class="mx-auto mt-1 max-w-[420px] text-[13px] leading-relaxed text-lais-text-muted"
    >
      {{ offerEmptyState.description }}
    </p>
    <button
      v-if="loadError"
      type="button"
      class="mt-4 inline-flex h-9 items-center gap-2 rounded-full border border-lais-border px-3 text-[12px] font-semibold text-lais-primary hover:border-lais-primary"
      @click="refreshOffers"
    >
      <span class="i-lucide-refresh-cw size-3.5" aria-hidden="true" />
      {{ offerEmptyState.buttonLabel || 'Atualizar página' }}
    </button>
    <button
      v-else-if="canLoadMore"
      type="button"
      class="mt-4 inline-flex h-9 items-center gap-2 rounded-full border border-lais-border px-3 text-[12px] font-semibold text-lais-primary hover:border-lais-primary"
      @click="loadMoreOffers"
    >
      <span class="i-lucide-chevron-down size-3.5" aria-hidden="true" />
      {{ offerEmptyState.buttonLabel || 'Ver mais' }}
    </button>
  </div>
</template>
